import Api from 'api';

import {
  GET_ASSET_LEVEL,
  SET_ASSET_LEVEL_PAGINATION,
  SET_ASSET_LEVEL_FILTERS,
  RESET_ASSET_LEVEL,
  TOGGLE_ASSET_LEVEL,
  ADD_ASSET_LEVEL,
  UPDATE_ASSET_LEVEL,
  GET_ASSET_LEVEL_BY_ID,
  RESET_ASSET_LEVEL_FORM,
  MODIFY_CUSTOM_FIELD_EDITING_ASSET_LEVEL, //Groups
  MODIFY_EDITING_ASSET_LEVEL,
} from 'asset_level/constants';

export const setPagination = (payload) => ({
  type: SET_ASSET_LEVEL_PAGINATION,
  payload,
});

export const setFilters = (payload) => ({
  type: SET_ASSET_LEVEL_FILTERS,
  payload,
});

export const getAssetLevel = (companyId, subcompanyId, filters, limit, page, orderBy, order) => ({
  type: GET_ASSET_LEVEL,
  payload: Api.asset_level.get(companyId, subcompanyId, filters, limit, page, orderBy, order),
});

export const reset = () => ({ type: RESET_ASSET_LEVEL });

export const toggleAssetLevel = (asset_levelId, companyId, subcompanyId) => ({
  type: TOGGLE_ASSET_LEVEL,
  meta: { id: asset_levelId },
  payload: Api.asset_level.toggle(asset_levelId, companyId, subcompanyId),
});

export const resetForm = () => ({ type: RESET_ASSET_LEVEL_FORM });

export const getAssetLevelById = (asset_levelId, companyId, subcompanyId) => ({
  type: GET_ASSET_LEVEL_BY_ID,
  meta: { needAuth: true },
  payload: Api.asset_level.getById(asset_levelId, companyId, subcompanyId),
});

export const modifyAssetLevel = (payload) => ({ type: MODIFY_EDITING_ASSET_LEVEL, payload });

//Groups
export const modifyCustomField = (payload) => ({
  type: MODIFY_CUSTOM_FIELD_EDITING_ASSET_LEVEL,
  payload,
}); // Agregado

export const addAssetLevel = (companyId, subcompanyId, asset_level) => ({
  type: ADD_ASSET_LEVEL,
  payload: Api.asset_level.add(companyId, subcompanyId, asset_level),
});

export const updateAssetLevel = (asset_levelId, companyId, subcompanyId, asset_level) => ({
  type: UPDATE_ASSET_LEVEL,
  meta: { id: asset_levelId, needAuth: true },
  payload: Api.asset_level.update(asset_levelId, companyId, subcompanyId, asset_level),
});



// WEBPACK FOOTER //
// src/modules/secured/modules/asset_level/actions/asset_level_actions.js